import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=d53161ba&scoped=true&"
import script from "./Subject.vue?vue&type=script&lang=js&"
export * from "./Subject.vue?vue&type=script&lang=js&"
import style0 from "./Subject.vue?vue&type=style&index=0&id=d53161ba&scoped=true&lang=css&"
import style1 from "./Subject.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53161ba",
  null
  
)

component.options.__file = "Subject.vue"
export default component.exports